import axios from "axios";
import { useEffect, useState } from "react";
import { Accordion, Breadcrumb, Col, Container, Row } from "react-bootstrap";
import { AiOutlineCodeSandbox } from "react-icons/ai";
import { FaUnlockAlt } from "react-icons/fa";
import { AiFillWindows } from "react-icons/ai";
import { MdAccountCircle } from "react-icons/md";
import window11productgroup from "../../../Assets/images/window11 productgroup.png";
import microsoftAuthorizedReseller from "../../../Assets/images/microsoft_authorized_reseller.png";
import window10pro1 from "../../../Assets/images/win10security.png";
import window10pro2 from "../../../Assets/images/bruce-mars-FWVMhUa_wbY-unsplash.jpg";
import window10pro3 from "../../../Assets/images/win10biz.jpeg";
import window10pro4 from "../../../Assets/images/Windows_10_desktop.png";
import window10pro5 from "../../../Assets/images/win10sec.png";
import window10pro6 from "../../../Assets/images/win10timeline.jpeg";

import { useNavigate } from "react-router-dom";
import { apiBaseURL } from "../../../Common/ApiHelper";
import { ToastContainer, toast } from "react-toastify";

const Window10Pro = ({ id }) => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [added, setAdded] = useState(
    localStorage.getItem("addedProducts")
      ? localStorage.getItem("addedProducts")
      : []
  );

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getProductById/?productId=${id}`,
      });
      if (response?.status === 200) {
        setTableData(response.data.data);
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (localStorage.getItem("cartItems")) {
      setCart(JSON.parse(localStorage.getItem("cartItems")));
    } else {
      localStorage.setItem("cartItems", JSON.stringify([]));
    }
  }, []);
  const handleAddCart = (product) => {
    product.quantity = 1;
    localStorage.setItem("cartItems", JSON.stringify([...cart, product]));
    setCart([...cart, product]);
    const updatedArray = JSON.parse(localStorage.getItem("cartItems")).map(
      (items) => items._id
    );
    setAdded(updatedArray);
    localStorage.setItem("addedProducts", JSON.stringify(updatedArray));
    toast.info("Product Added", {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
    navigate(`${window.location.pathname}`);
  };
  return (
    <>
      <ToastContainer />
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Window 10 Professional</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          {loading ? (
            <>
              <div class="d-flex justify-content-center ">
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="product_details_with_image box_shadow">
                <Row>
                  <Col xxl="3" lg="3" md="12">
                    <div className="product_image pt-4">
                      <img
                        src={tableData.productImage}
                        alt="Product"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Col>
                  <Col xxl="7" lg="7" md="12">
                    <div className="product_details pt-5 pb-4">
                      <h1>{tableData.name}</h1>
                      <p>
                        Retail Version |{" "}
                        {tableData?.retailVersion[0]?.split(":").join(": ")}
                      </p>
                      <img
                        src={window11productgroup}
                        alt="Product inner products images"
                        className="mb-4"
                      />
                      <div className="include_product_purchase">
                        <p className="font-weight-bold">
                          Included In Your Purchase:
                        </p>
                        <p>
                          Download Your Software Directly From Microsoft <br />
                          Activation Key For Windows 10 Professional <br />
                          PDF Intructions For Download & Activation <br />
                          Lifetime Live Chat Support & Assistance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xxl="2" lg="2" md="12">
                    <div className="price_details pt-5 pb-4">
                      <p className="font-weight-bold product_price mb-0">
                        ${tableData.salePrice} USD
                      </p>
                      {added.includes(tableData._id) ? (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => navigate("/cart")}
                        >
                          Go To Cart
                        </button>
                      ) : (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => handleAddCart(tableData)}
                        >
                          Add To Cart
                        </button>
                      )}

                      <div className="product_have_questions">
                        <h3>Have Questions?</h3>
                        <p>
                          Call +1 (833) 465 0300 <br /> or contact us via chat
                        </p>
                      </div>
                      <div className="microsoft_partner">
                        <img
                          src={microsoftAuthorizedReseller}
                          alt="productgroupImg"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <div className="extraInfo_tabs mt-4">
            <Row>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing</h5>
                  <p className="mb-0">Retail</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing Term</h5>
                  <p className="mb-0">Lifetime</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Users Supported</h5>
                  <p className="mb-0">1 User </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Devices Supported</h5>
                  <p className="mb-0">1 Device </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Delivery Method</h5>
                  <p className="mb-0">Instant Digital Delivery</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4   ">
                  <h5>Platform Supported</h5>
                  <p className="mb-0">Windows</p>
                </div>
              </Col>
            </Row>
          </div>
          <div className="product_long_description">
            <Row>
              <Col xxl="9" md="9" sm="12">
                <div className="box_shadow mb-2 me-3">
                  <div className="product_main_description top_radius">
                    <h3 className="mb-0">Product Description</h3>
                    <p className="mt-4">
                      If you’re looking for a reliable and secure operating
                      system, look no further than Windows 10 Pro. Windows 10
                      Pro has many features that make it the ideal operating
                      system for any business or professional looking to get the
                      most out of their device. Windows 10 Pro provides the
                      strong and reliable foundation needed in order to complete
                      even the most difficult, resource-heavy projects
                    </p>
                  </div>
                  <div className="product_grey">
                    <h3 className="d-flex justify-content-center product_details_heading px-5 pt-5 mb-3">
                      Why Choose Windows 10 Pro
                    </h3>
                    <p className="d-flex justify-content-center product_description_p px-4 py-3">
                      A halo of protection to defend against today's cyber
                      threats. Built-in, routinely updated, and at no extra cost
                      to you.
                    </p>
                    <div className="product_grey px-5">
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <img
                            className=" productImg_description product_white"
                            src={window10pro1}
                            alt="productDescription"
                          />
                          <div>
                            <h5 className="product_description_head my-3">
                              Security Protection
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Windows 10 Pro includes firewall and internet
                              protections to help safeguard against viruses and
                              malware.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <img
                            className=" productImg_description product_white"
                            src={window10pro2}
                            alt="productDescription"
                          />
                          <div>
                            <h5 className="product_description_head my-3">
                              Take Your Business Where You Go
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              You love your mobile. So does your PC. Continue
                              where you left off, wherever you left off. Read,
                              write, and edit, across all your devices.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <img
                            className=" productImg_description product_white"
                            src={window10pro3}
                            alt="productDescription"
                          />
                          <div>
                            <h5 className="product_description_head my-3">
                              Smoothly Manage Your Business
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Microsoft Windows 10 Pro offers you simple and
                              flexible management, so you can easily do more the
                              way you want to.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <img
                            className=" productImg_description product_white"
                            src={window10pro4}
                            alt="productDescription"
                          />
                          <div>
                            <h5 className="product_description_head my-3">
                              An Experience You Know
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              The Start Menu and Search Bar make it easy to find
                              thing quickly. Organize, edit, and share your
                              photos and videos easily. Browse the internet
                              faster with Microsoft Edge.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <img
                              className=" productImg_description product_white"
                              src={window10pro5}
                              alt="productDescription"
                            />
                          </div>
                          <div>
                            <h5 className="product_description_head my-3">
                              Security Comes Standard
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Rest-assured knowing Windows comes with built-in
                              security features. Including firewall and internet
                              protections to keep your PC safe.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <img
                            className=" productImg_description product_white"
                            src={window10pro6}
                            alt="productDescription"
                          />
                          <div>
                            <h5 className="product_description_head my-3">
                              New Ways To Be Productive
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Get to done faster with Timeline and Focus Assist.
                              And with your Phone app, there is no need to dig
                              for your phone - simply access your texts and
                              photos right on your PC.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="product_white bottom_radius pt-4">
                    <h3 className=" product_details_heading px-5 py-5 mb-3">
                      More Features & Benefits
                    </h3>
                    <div className="product_white px-5 pb-4 bottom_radius">
                      <Row>
                        <Col xxl="6" xl="6" lg="12" sm="12">
                          <div>
                            <AiOutlineCodeSandbox className="product_icons" />
                            <h5 className="product_description_head my-3">
                              Windows Sandbox
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              It's half app, half virtual machine. It allows you
                              to quickly run a freshly installed virtual
                              operating machine so you can test programs or
                              files in a secure enviroment that's isolated from
                              your main system.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="6" xl="6" lg="12" sm="12">
                          <div>
                            <FaUnlockAlt className="product_icons" />
                            <h5 className="product_description_head my-3">
                              BitLocker
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              BitLocker is a feature which automatically
                              encrypts your entire harddrive, utlilizing either
                              128- or 256-bit AES algorithm to protect your data
                              from hackers and theft.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="6" xl="6" lg="12" sm="12">
                          <div>
                            <AiFillWindows className="product_icons" />
                            <h5 className="product_description_head my-3">
                              Windows Defender
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Windows Defender is your free built-in antivirus
                              tool from Microsoft to help protect your PC
                              against viruses, ransomware, and other malware.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="6" xl="6" lg="12" sm="12">
                          <div>
                            <MdAccountCircle className="product_icons" />
                            <h5 className="product_description_head my-3">
                              Cortana
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Cortana is your very own personal productivity
                              assistant that helps you save time and focus
                              attention on what matters most.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="3" xl="3" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-5">
                              + Hyper-V Technology
                            </h5>
                          </div>
                        </Col>
                        <Col xxl="3" xl="3" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-5">
                              + Kiosk Mode
                            </h5>
                          </div>
                        </Col>
                        <Col xxl="3" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-5">
                              + Remote Desktop
                            </h5>
                          </div>
                        </Col>
                        <Col xxl="3" xl="3" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-5">
                              + Windows Updates
                            </h5>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="3" xl="3" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3 mb-5">
                              + Windows Hello
                            </h5>
                          </div>
                        </Col>
                        <Col xxl="3" xl="3" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3 mb-5">
                              + Timeline
                            </h5>
                          </div>
                        </Col>
                        <Col xxl="3" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3 mb-5">
                              + Voice, Pen, & Touch
                            </h5>
                          </div>
                        </Col>
                        <Col xxl="3" xl="3" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3 mb-5">
                              And More..
                            </h5>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                <div className="product_accordion mt-5 me-3">
                  <Accordion>
                    <Accordion.Item eventKey="0" className=" box_shadow">
                      <Accordion.Header>
                        What is a digital download?
                      </Accordion.Header>
                      <Accordion.Body>
                        A digital download is an electronic version of your
                        software product which gives you access to download and
                        use your software immediately. This means a physical
                        package is not included with your purchase. You will
                        have the option to create a disc or USB at home or in
                        the office. Our support team would be happy to help
                        guide you through the process.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className=" box_shadow">
                      <Accordion.Header>
                        What is the difference between OEM & Retail licenses?
                      </Accordion.Header>
                      <Accordion.Body>
                        OEM licenses are pre-installed on the device and are
                        backed by the vendor. Retail licenses are powered by
                        Microsoft. You are free to install your product on any
                        device. Retail versions may be transferred to new
                        hardware but may only be installed on one device at a
                        time.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className=" box_shadow">
                      <Accordion.Header>
                        How can I guarantee that my copy of Microsoft software
                        is authentic?
                      </Accordion.Header>
                      <Accordion.Body>
                        Liberty Programs only purchases and distributes software
                        and licensing keys through our trusted Microsoft Partner
                        vendors. <br />
                        Any software purchased from Liberty Programs is covered
                        by our hassle-free 90-day money-back guarantee. We
                        encourage all of our customers to register their
                        Microsoft product key via the Microsoft phone activation
                        to ensure authenticity of their purchased products.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className=" box_shadow">
                      <Accordion.Header>
                        Will my license key expire?
                      </Accordion.Header>
                      <Accordion.Body>
                        No, any product purchased from Liberty Programs is a
                        retail version which includes a lifetime license of your
                        software.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className=" box_shadow">
                      <Accordion.Header>
                        How long until I recieve my order?
                      </Accordion.Header>
                      <Accordion.Body>
                        Your order will typically be processed immediately.
                        Please login in to your account area with the
                        credentials given during the checkout process to find
                        your download media and license keys.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className=" box_shadow">
                      <Accordion.Header>
                        How do I download my software?
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your download media for your purchased
                        software in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6" className=" box_shadow">
                      <Accordion.Header>
                        Where can I find the license keys to activate my
                        software
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your license key for your purchased
                        products in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7" className=" box_shadow">
                      <Accordion.Header>
                        How do I get help with my installation?
                      </Accordion.Header>
                      <Accordion.Body>
                        We offer a step-by-step PDF document that walks you
                        through the download process . If you need more
                        assistance please contact our support team and we would
                        be happy to help you with the installation via chat or
                        remote installation.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
              <Col xxl="3" md="3" sm="12">
                <div className="product_sidebar_widget darkblue_bg box_shadow">
                  <h4>256-bit SSL Encrypted Checkout</h4>
                  <p>
                    All personal information is protected by state of the art
                    SSL certified encryption.{" "}
                  </p>
                  <hr />
                  <h4>24/7 Tech Support Available</h4>
                  <p>
                    Your purchase with Liberty Programs includes around the
                    clock support from our technical experts. <br />
                    <br />
                    Our team of highly trained professionals make software
                    installations a breeze, helping to identify problems and
                    provide immediate solutions that may arise during and after
                    the installation of software.
                  </p>
                  <hr />
                  <h4>Your Business Is Important To Us</h4>
                  <p>
                    We value our customers and appreciate your business with us.
                    <br />
                    <br />
                    Whether you're an individual upgrading your software or a
                    business upgrading their network, we're here 24/7 to provide
                    hands on support and troubleshooting.
                    <br />
                    <br />
                    All software downloads are provided directly from Microsoft
                    with a genuine license key for activation. <br />
                    <br />
                    If you have any concerns regarding the authenticity of your
                    software, please call (833) 465 0300 or contact us via chat
                  </p>
                  <hr />
                  <h4>90-Day Money Back Guarantee</h4>
                  <p>
                    If for any reason you are not completely satisfied with your
                    purchase from us please contact our refund department
                    directly at sales@libertyprograms.com
                    <br />
                    <br />
                    If we cannot resolve your ticket, a full refund will be
                    issued regardless of our 90-day money back guarantee. <br />
                    <br />
                    Terms & conditions apply.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Window10Pro;
